/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * DHTMLX Scheduler událost s informacemi v iCalendar formátu
 */
class DhtmlxToIcalEvent {
  /**
   * @param {IcalApi} ICAL
   * @param {string} dateFormat Formát datumů v DHTML události
   * @param {DhtmlxDateParser} dateParser
   * @param {DhtmlxEvent} event DHTMLX událost
   */
  constructor(ICAL, dateFormat, dateParser, event) {
    this.ICAL = ICAL;
    this.dateFormat = dateFormat;
    this.dateParser = dateParser;
    this.event = event;
  }

  /**
   * Datum konce události viz. {@link DhtmlxEvent#end_date}
   * @returns {IcalApi.Time}
   */
  getEndDate() {
    const jsDate = this.dateParser.parse(this.event.end_date, this.dateFormat);
    return this.ICAL.Time.fromJSDate(jsDate);
  }

  /**
   * Originální DHTMLX událost
   * @returns {DhtmlxEvent}
   */
  getEvent() {
    return this.event;
  }

  /**
   * Identifikátor události viz. {@link DhtmlxEvent#id}
   * @returns {string}
   */
  getId() {
    return this.event.id;
  }

  /**
   * Délka události jako viz. {@link DhtmlxEvent#event_length}
   * @returns {number}
   */
  getLength() {
    // TODO Když by byl event_length "", nemělo by být undefined?
    return Number(this.event.event_length);
  }

  /**
   * Identifikátor rodičovské události viz. {@link DhtmlxEvent#event_pid}
   * @returns {string}
   */
  getParentId() {
    return this.event.event_pid;
  }

  /**
   * Parametry pro opakování události viz. {@link DhtmlxEvent#rec_type}
   * @returns {string}
   */
  getRecType() {
    return this.event.rec_type;
  }

  /**
   * Datum začátku události viz. {@link DhtmlxEvent#start_date}
   * @returns {IcalApi.Time}
   */
  getStartDate() {
    const jsDate = this.dateParser.parse(
      this.event.start_date,
      this.dateFormat
    );
    return this.ICAL.Time.fromJSDate(jsDate);
  }

  /**
   * Popis události viz. {@link DhtmlxEvent#text}
   * @returns {string}
   */
  getText() {
    return this.event.text;
  }
}

export default DhtmlxToIcalEvent;
